export default __webpack_public_path__ + "static/media/Marquise@1x.a6b4675a.png";